import React, { useState, useEffect } from 'react';
// import styles from './ShotWizardPage.module.scss';
import { ShotView, WizardGroups } from 'components';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_STORE, ALL_LOCATIONS, UNLOCATED_SHOTS, EDITOR_SHOTS_STORE, EDITOR_LOCATIONS_STORE, EDITOR_GROUPS_STORE } from 'store';
import TabsPageContainer from '../TabsPageContainer';
import { ShotWizardPageProps } from './types';

const tabs = ['all', 'ungrouped', 'by group'];

const ShotWizardPage = (props: ShotWizardPageProps) => {
  const {
    [EDITOR_SHOTS_STORE]: {
      getVideoShots,
      shots,
      sortedShotIds,
      isShotSelected
    },
    [EDITOR_GROUPS_STORE]: {
      selectedGroups,
      setFilterGroupsBySelectedLocation
    },
    [EDITOR_LOCATIONS_STORE]: {
      locationNames,
      selectLocation,
      selectedLocation
    },
    [EDITOR_STORE]: {
      videoEntityId,
      setProjectId,
      getProjectDetails
    },
    match: { params: { projectId, videoEntityId: paramVideoEntityId } },
  } = props;

  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  useEffect(() => {
    if (!videoEntityId) {
      getVideoShots(paramVideoEntityId);
      setProjectId(projectId);
    }
    setFilterGroupsBySelectedLocation(true);
    // Solve Black frame issue
    getProjectDetails(projectId)

    return setFilterGroupsBySelectedLocation;
  }, [
    getVideoShots, projectId,
    paramVideoEntityId, videoEntityId,
    setFilterGroupsBySelectedLocation, setProjectId
  ]);

  const isShotVisible = shot => {
    const nonSpecificLocations = [null, ALL_LOCATIONS, UNLOCATED_SHOTS];
    const isActualLocationSelected = !nonSpecificLocations.includes(selectedLocation);
    // console.log('isActualLocationSelected', isActualLocationSelected);
    const doesSelectedLocationMismatch = isActualLocationSelected && shot.location !== selectedLocation;
    if (doesSelectedLocationMismatch) return false;
    if (selectedLocation === UNLOCATED_SHOTS && shot.location) return false;

    switch (selectedTab) {
      case tabs[1]:
        return !shot.name;

      case tabs[2]:
        return selectedGroups.includes(shot.name);

      default:
        return true;
    }
  };

  const isByGroupTabSelected = () => {
    return selectedTab === tabs[2];
  };

  const isShotAvailableForSelectedGroup = shot => {
    if (selectedGroups.length !== 1) return false;
    if (selectedGroups[0] === '<1sec') return false;
    if (selectedGroups[0] === shot.name) return false;
    return true;
  };

  return (
    <TabsPageContainer
      tabs={tabs}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      sideComponent={<WizardGroups />}
      filterOptions={[ALL_LOCATIONS, ...locationNames]}
      selectedFilter={selectedLocation}
      onFilterSelect={selectLocation}
    >
      {sortedShotIds.map((shotId, index) => {
        const shot = shots[shotId];
        return isShotVisible(shot)
          ? <ShotView
            key={shotId}
            shot={shot}
            isSelected={isByGroupTabSelected() ? false : isShotSelected(shot)}
            availableForGroup={isShotAvailableForSelectedGroup(shot)}
            nextShotId={sortedShotIds[index + 1] || null}
          />
          : null;
      }
      )}
    </TabsPageContainer>
  );
};

export default inject(
  EDITOR_STORE, EDITOR_SHOTS_STORE,
  EDITOR_LOCATIONS_STORE, EDITOR_GROUPS_STORE
)(observer(ShotWizardPage));
